import type { ScaleLinear } from 'd3-scale';
import { type PropsWithChildren } from 'react';

import type { TruncationMode } from '@dynatrace/strato-components/typography';
import { Unit, ConvertibleUnit, FormatOptions } from '@dynatrace-sdk/units';

import { StoreProvider } from './StoreProvider.js';
import { Formatter } from '../../../../types/formatter.js';
import { ChartLegendOrientation } from '../../../../types/legend.js';
import { FormatterContext } from '../context/FormatterContext.js';
import { RangeLegendOrientationContext } from '../context/RangeLegendOrientationContext.js';
import { RangeLegendScaleContext } from '../context/RangeLegendScaleContext.js';
import { RangeLegendTruncationContext } from '../context/RangeLegendTruncationContext.js';

interface RangeLegendProvidersProps {
  formatter: Formatter | FormatOptions<Unit, ConvertibleUnit>;
  orientation: ChartLegendOrientation;
  scale: ScaleLinear<number, number>;
  truncationMode: TruncationMode;
}

export const RangeLegendProviders = (
  props: PropsWithChildren<RangeLegendProvidersProps>,
) => {
  const { formatter, orientation, scale, truncationMode, children } = props;

  return (
    <FormatterContext.Provider value={{ formatter }}>
      <RangeLegendOrientationContext.Provider value={{ orientation }}>
        <RangeLegendScaleContext.Provider value={{ scale }}>
          <RangeLegendTruncationContext.Provider value={truncationMode}>
            <StoreProvider>{children}</StoreProvider>
          </RangeLegendTruncationContext.Provider>
        </RangeLegendScaleContext.Provider>
      </RangeLegendOrientationContext.Provider>
    </FormatterContext.Provider>
  );
};
